import { useContext } from 'react';

import CallContext from './context';

const useCall = () => useContext(CallContext);

export default useCall;
